import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=d418f4e2"
import script from "./Allocation.vue?vue&type=script&lang=js"
export * from "./Allocation.vue?vue&type=script&lang=js"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=d418f4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports